module.exports = __webpack_public_path__ + "static/media/background-home.8863bd21.png";